import { render, staticRenderFns } from "./ClinicsComponent.vue?vue&type=template&id=10435777&"
import script from "./ClinicsComponent.vue?vue&type=script&lang=js&"
export * from "./ClinicsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports